<template>
  <div class="template-data-grid-view">
    <template v-if="filters.length">
      <template v-if="position === 'TITLE' && filterKey">
        <keep-alive>
          <TemplateDataGrid ref="dataGrid"
                            :key="filterKey"
                            v-bind="$extend($attrs, filterCache[filterKey])"
                            v-on="$listeners">
            <template #title="{title}">
              <div class="template-data-grid-view-header">
                <TemplateDataGridFilter :filters="filters"
                                        :use-filter-param="filterCache[filterKey]"
                                        @filterKeyChange="onFilterKeyChange"></TemplateDataGridFilter>
                <div class="grid-title">{{title}}</div>
              </div>
            </template>
          </TemplateDataGrid>
        </keep-alive>
      </template>
      <template v-else>
        <TemplateDataGridFilter :filters="filters"
                                @filterKeyChange="onFilterKeyChange">
          <template #default="{filterKey, filterParam}">
            <keep-alive>
              <TemplateDataGrid ref="dataGrid"
                                :key="filterKey"
                                v-bind="$extend($attrs, filterParam)"
                                v-on="$listeners"></TemplateDataGrid>
            </keep-alive>
          </template>
        </TemplateDataGridFilter>
      </template>
    </template>
    <template v-else>
      <TemplateDataGrid v-bind="$attrs"
                        v-on="$listeners"></TemplateDataGrid>
    </template>
  </div>
</template>

<script>
import TemplateDataGridFilter from './TemplateDataGridFilter'
import TemplateDataGrid from '../TemplateDataGrid'
export default {
  name: 'TemplateDataGridView',
  components: {
    TemplateDataGridFilter,
    TemplateDataGrid
  },
  props: {
    position: String,
    filters: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      filterKey: '',
      filterCache: {}
    }
  },
  methods: {
    onFilterKeyChange ({filterKey, filterParam}) {
      this.filterKey = filterKey
      this.filterCache[filterKey] = filterParam
    },
    loadGridData () {
      const dataGrid = this.$refs['dataGrid']
      if (dataGrid) {
        dataGrid.loadGridData()
      }
    }
  }
}
</script>

<style lang="scss">
.template-data-grid-view {
  height: 100%;
}
.template-data-grid-view-header {
  display: flex;
  align-items: center;
}
</style>
